<template>
    <!-- 消息通知 -->
    <div id="system" v-loading="loading">
      <div class="pAHeader">
        <div class="pAHeader1">系统管理</div>
      </div>
      <hr>
      <div id="SystemBtn">
        <div class="setSystemBtn">
            <span>关闭网站</span>
            <el-switch
              v-model="closeWeb"
              @change="ChangeCloseWebState"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
        </div>
      </div>
    </div>
  </template>
  
  <script>
      export default {
        components:{

          },
        data() {
          return {
            closeWeb:false,
            loading:false,
          }
        },
        methods:{
            ChangeCloseWebState(){
                this.loading = true;
                this.ajax.post(this.$store.state.api+'/setSystemState',{
                    uid:this.$store.state.userInfo.userid,
                    st:Number(this.closeWeb)
                }).then(res=>{
                    if(res['data']==1){
                        this.$message.success(`更改系统状态成功`);
                        this.getCloseData();
                    }
                }).catch(err=>{
                    console.log(err);
                })
            },
            getCloseData(){
                this.loading = true;
                this.ajax.get(this.$store.state.api+'/getSystemState',{
                    uid:this.$store.state.userInfo.userid
                }).then(res=>{
                    let state = res['data'][0][0]['state'];
                    //是否关闭网站
                    this.closeWeb = Boolean(state);
                    this.loading = false;
                }).catch(err=>{
                    console.log(err)
                })
            },
        },
        watch:{

      },
        mounted(){
            this.getCloseData();
        }
        
      }
  </script>
  
  <style lang="less" scoped>
  #system{
    width: 100%;
    height: 100%;
    #SystemBtn{
        margin-top: 40px;
        width: 100%;
        .setSystemBtn{
            font-size: 18px;
            span{
                margin-right: 10px;
            }
        }
    }
  }
  </style>